import { Box, Button, IconButton, styled, Typography } from '@mui/material';

export const BannerContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isClosing',
})<{ isClosing?: boolean }>(({ isClosing }) => ({
  position: 'relative',
  padding: '0.5rem',
  background: '#1b252500',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  opacity: isClosing ? 0 : 1,
  transform: isClosing ? 'translateY(-10px)' : 'translateY(0)',
  transition: 'opacity 400ms ease-out, transform 400ms ease-out',
  width: '100%',
}));

export const BannerContent = styled(Box)({
  width: '100%',
  position: 'relative',
  height: '14rem',
  padding: '1rem',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
  border: '0.25px solid #AECBD0',
  background: '#2F736E1F',
  boxSizing: 'border-box',
  overflow: 'hidden',
  gap: '0.5rem',
  paddingBottom: '1.25rem',
});

export const BannerCloseButton = styled(IconButton)({
  position: 'absolute',
  top: '0.75rem',
  right: '0.75rem',
  transform: 'translate(50%, -50%)',
  zIndex: 1,
  width: '1.5rem',
  height: '1.5rem',
  padding: 0,
  backgroundColor: '#AECBD0',
  color: '#2F736E',

  '&:hover': {
    backgroundColor: '#AECBD0',
  },
});

export const BannerBadge = styled(Box)({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  minWidth: '5.5rem',
  borderRadius: '1.5rem',
  padding: '0.2rem 0.65rem',
  backgroundColor: '#AECBD0',
  color: '#1b2525',
  border: '#1b2525',
  fontSize: '0.75rem',
  lineHeight: '1rem',
  fontWeight: 700,
});

export const BannerTitle = styled(Typography)({
  color: '#F6F8F9',
  fontSize: '1rem',
  lineHeight: '1.2rem',
  fontWeight: 700,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitBoxPack: 'center',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 0,
});

export const BannerDescription = styled(Typography)({
  color: '#B4B4B4',
  fontSize: '0.8125rem',
  lineHeight: '1.2rem',
  fontWeight: 700,
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  flexShrink: 0,
});

export const BannerButton = styled(Button)({
  marginTop: 'auto',

  width: '100%',
  height: '2.5rem',
  minHeight: '2.5rem',
  padding: '0.5rem 1rem',

  flexShrink: 0,
  justifyContent: 'space-between',
  alignItems: 'center',
  boxSizing: 'border-box',

  backgroundColor: '#2F736E12',
  color: '#F6F8F9',
  fontWeight: 700,
  fontSize: '0.875rem',
  borderRadius: '5rem',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#2F736E12',
    boxShadow: 'none',
  },
});

export const BannerDots = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '0.4rem',
  marginTop: '0.25rem',
});

export const BannerDot = styled(Box)({
  width: '0.4rem',
  height: '0.4rem',
  borderRadius: '50%',
  backgroundColor: '#6C7A78',
  transition: 'all 0.3s ease',
});

export const ActiveBannerDot = styled(Box)({
  width: '0.5rem',
  height: '0.5rem',
  borderRadius: '50%',
  backgroundColor: '#FFFFFF',
  transition: 'all 0.3s ease',
});
